var render = function () {
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-form', {
    ref: "chargingStationForm",
    model: {
      value: _vm.valid,
      callback: function callback($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-container', [_c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.name'),
      "required": "",
      "outlined": "",
      "data-test-form-name": ""
    },
    model: {
      value: _vm.chargingStation.name,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation, "name", $$v);
      },
      expression: "chargingStation.name"
    }
  }), _c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "label": _vm.$t('components.thg.ThgChargingStationForm.commissioningDate'),
            "rules": _vm.dateRule,
            "required": "",
            "outlined": "",
            "data-test-form-commissioningDate": ""
          },
          model: {
            value: _vm.chargingStation.commissioningDate,
            callback: function callback($$v) {
              _vm.$set(_vm.chargingStation, "commissioningDate", $$v);
            },
            expression: "chargingStation.commissioningDate"
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.isDatepickerMenuActive,
      callback: function callback($$v) {
        _vm.isDatepickerMenuActive = $$v;
      },
      expression: "isDatepickerMenuActive"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "active-picker": _vm.activePicker,
      "max": new Date().toISOString().substr(0, 10),
      "min": "2010-01-01"
    },
    on: {
      "update:activePicker": function updateActivePicker($event) {
        _vm.activePicker = $event;
      },
      "update:active-picker": function updateActivePicker($event) {
        _vm.activePicker = $event;
      }
    },
    model: {
      value: _vm.chargingStation.commissioningDate,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation, "commissioningDate", $$v);
      },
      expression: "chargingStation.commissioningDate"
    }
  })], 1), _c('v-text-field', {
    attrs: {
      "rules": _vm.numberRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.connectionPowerInKwh'),
      "required": "",
      "outlined": "",
      "type": "number",
      "data-test-form-connection-power": ""
    },
    model: {
      value: _vm.chargingStation.connectionPowerInKwh,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation, "connectionPowerInKwh", $$v);
      },
      expression: "chargingStation.connectionPowerInKwh"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.numberRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.chargingPointCount'),
      "required": "",
      "outlined": "",
      "type": "number",
      "data-test-form-charging-point-count": ""
    },
    model: {
      value: _vm.chargingStation.chargingPointCount,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation, "chargingPointCount", $$v);
      },
      expression: "chargingStation.chargingPointCount"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.isRegisteredItems,
      "label": _vm.$t('components.thg.ThgChargingStationForm.isRegistered'),
      "outlined": "",
      "data-test-form-registered": ""
    },
    model: {
      value: _vm.chargingStation.isRegistered,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation, "isRegistered", $$v);
      },
      expression: "chargingStation.isRegistered"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t("components.thg.ThgChargingStationForm.location")))]), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.street'),
      "required": "",
      "outlined": "",
      "data-test-form-street": ""
    },
    model: {
      value: _vm.chargingStation.address.street,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation.address, "street", $$v);
      },
      expression: "chargingStation.address.street"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.germanZipRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.zip'),
      "required": "",
      "outlined": "",
      "data-test-form-zip": ""
    },
    model: {
      value: _vm.chargingStation.address.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation.address, "zip", $$v);
      },
      expression: "chargingStation.address.zip"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.city'),
      "required": "",
      "type": "",
      "outlined": "",
      "data-test-form-city": ""
    },
    model: {
      value: _vm.chargingStation.address.city,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingStation.address, "city", $$v);
      },
      expression: "chargingStation.address.city"
    }
  }), _c('v-radio-group', {
    attrs: {
      "row": "",
      "data-test-form-isCompany": ""
    },
    model: {
      value: _vm.isCompany,
      callback: function callback($$v) {
        _vm.isCompany = $$v;
      },
      expression: "isCompany"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.private'),
      "value": false,
      "data-test-form-isprivate": ""
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.corporateClient'),
      "value": true,
      "data-test-form-iscompany": ""
    }
  })], 1), _vm.isCompany ? _c('v-text-field', {
    attrs: {
      "value": _vm.chargingPointOperator.name,
      "label": _vm.$t('report.thgContactData.companyName'),
      "rules": _vm.requiredRule,
      "required": "",
      "outlined": "",
      "data-test-form-company": ""
    }
  }) : _vm._e(), _vm.isCompany ? _c('v-text-field', {
    attrs: {
      "value": _vm.chargingPointOperator.managingDirectorName,
      "label": _vm.$t('report.thgContactData.managingDirectory'),
      "outlined": "",
      "data-test-form-company": ""
    }
  }) : _vm._e(), _vm.isCompany ? _c('span', [_c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.street'),
      "required": "",
      "outlined": "",
      "data-test-form-operator-address--street": ""
    },
    model: {
      value: _vm.chargingPointOperator.address.street,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingPointOperator.address, "street", $$v);
      },
      expression: "chargingPointOperator.address.street"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.germanZipRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.zip'),
      "required": "",
      "outlined": "",
      "data-test-form-operator-address--zip": ""
    },
    model: {
      value: _vm.chargingPointOperator.address.zip,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingPointOperator.address, "zip", $$v);
      },
      expression: "chargingPointOperator.address.zip"
    }
  }), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRule,
      "label": _vm.$t('components.thg.ThgChargingStationForm.city'),
      "required": "",
      "outlined": "",
      "data-test-form-operator-address-city": ""
    },
    model: {
      value: _vm.chargingPointOperator.address.city,
      callback: function callback($$v) {
        _vm.$set(_vm.chargingPointOperator.address, "city", $$v);
      },
      expression: "chargingPointOperator.address.city"
    }
  }), _c('v-card-title', [_vm._v(_vm._s(_vm.$t("report.thgContactData.taxnumberTitle")))]), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: _vm.isResubmittingTaxnumber,
      callback: function callback($$v) {
        _vm.isResubmittingTaxnumber = $$v;
      },
      expression: "isResubmittingTaxnumber"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.register'),
      "value": false,
      "data-test-form-isNotResubmittingTaxnumber": ""
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('report.thgContactData.resubmit'),
      "value": true,
      "data-test-form-isResubmittingTaxnumber": ""
    }
  })], 1), !_vm.isResubmittingTaxnumber ? _c('v-card-text', [_vm._v(" " + _vm._s(_vm.$t("report.thgContactData.taxnumberDescription")) + " ")]) : _vm._e(), !_vm.isResubmittingTaxnumber ? _c('v-text-field', {
    attrs: {
      "value": _vm.taxnumber,
      "label": _vm.$t('report.thgContactData.taxnumber'),
      "rules": [function (v) {
        return !!v || _this.$t('report.thgContactData.mandatoryInput');
      }],
      "required": "",
      "outlined": "",
      "data-test-form-taxnumber": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "color": "primary",
      "disabled": !_vm.valid,
      "data-test-form-submit": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.thg.ThgMeterReadingForm.submit")) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }